import { ref } from 'vue'

const toasts = ref([])
let seq = 0

export function useToast() {
  function dismiss(id) {
    toasts.value = toasts.value.filter(t => t.id !== id)
  }

  function toast(msg, kind) {
    const id = ++seq
    toasts.value.push({ id, msg, kind })
    // Errors linger (10s) so they can be read/acted on; everything else is
    // transient (3s). Both can be dismissed manually via the close button.
    const ttl = kind === 'error' ? 10000 : 3000
    setTimeout(() => dismiss(id), ttl)
    return id
  }

  return { toasts, toast, dismiss }
}
